import React from "react";
import ReactDOM from "react-dom/client";
import "./assets/css/index.css";
import App from "./App";
import reportWebVitals from "./pwa/reportWebVitals";
import { ConfigProvider } from "antd";
import esEs from "antd/locale/es_ES";

const root = ReactDOM.createRoot(document.getElementById("root"));

const theme = {
  token: {
    colorPrimary: "#00f3ff",
    colorBgBase: "#050608",
    colorTextBase: "#ffffff",
    borderRadius: 4,
    fontFamily: "'Inter', sans-serif",
  },
  components: {
    Layout: {
      headerBg: "rgba(5, 6, 8, 0.8)",
    }
  }
};

root.render(
  <React.StrictMode>
    <ConfigProvider locale={esEs} theme={theme}>
      <App />
    </ConfigProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
